import { useEffect, useState } from 'react';

function VerifyCompatibility() {
  const [isIncompatible, setIsIncompatible] = useState(false);

  useEffect(() => {
    const checkCompatibility = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Detectar iOS
      if (/iP(hone|od|ad)/.test(navigator.platform)) {
        const match = userAgent.match(/OS (\d+)_/);
        if (match && parseInt(match[1], 10) <= 16) return true;
      }

      // Detectar Android
      if (/Android/.test(userAgent)) {
        const match = userAgent.match(/Android\s([0-9.]*)/);
        if (match && parseFloat(match[1]) <= 8.0) return true;
      }

      return false;
    };

    if (checkCompatibility()) {
      setIsIncompatible(true);
    }
  }, []);

  if (!isIncompatible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#fff0f0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '2rem',
      zIndex: 99999,
    }}
    >
      <h2 style={{ color: '#d00000' }}>Dispositivo no compatible</h2>
      <p style={{ fontSize: '1.2rem' }}>
        Esta aplicación no es compatible con:
        <br />
        - iOS en versiones menores a
        {' '}
        <strong>16</strong>
        <br />
        - Android en versiones menores a
        {' '}
        <strong>8.0</strong>
        <br />
        <br />
        Por favor, actualiza tu sistema operativo para continuar.
      </p>
      <h2 style={{ color: '#d00000' }}>Incompatible Device</h2>
      <p style={{ fontSize: '1.2rem' }}>
        This application is not compatible with:
        <br />
        - iOS versions lower than <strong>16</strong>
        <br />
        - Android versions lower than <strong>8.0</strong>
        <br />
        <br />
        Please update your operating system to continue.
      </p>
    </div>
  );
}

export default VerifyCompatibility;
